import { Divider } from "@mui/material";
import React from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import SearchIcon from "@mui/icons-material/Search";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const InfoOrderModal = (props) => {
    const [open, setOpen] = React.useState(false);
    
    let order = props.order;
    let dateCreated = order?.date_created ? new Date(order.date_created) : null;
    let dateDelivery = order?.date_delivery ? new Date(order.date_delivery) : null;
    let client = order?.ordersDetail ? order.ordersDetail.length > 0 ? order.ordersDetail[0].productPrice.client : null : null;

    const handleOpen = () => {
        setOpen(true);    
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <div>
            <Button variant='contained' size='small' onClick={handleOpen}>Ver detalle</Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <div style={{display: 'flex', flexDirection: 'column', width: '80%'}}>
                            <strong></strong>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row-reverse', width: '20%'}}>
                            <Button size='small' onClick={handleClose}>Cerrar</Button>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Número de orden: </span>
                        <span>{order?.id}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Fecha de orden: </span>
                        <span>{dateCreated ? `${dateCreated.getDate()} / ${dateCreated.getMonth() + 1} / ${dateCreated.getFullYear()}` : 'Sin Fecha'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Fecha de entrega: </span>
                        <span>{dateDelivery ? `${dateDelivery.getDate()} / ${dateDelivery.getMonth() + 1} / ${dateDelivery.getFullYear()}` : 'INMEDIATO'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Cliente: </span>
                        <span>{client ? client.name : 'Sin Cliente'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Código: </span>
                        <span>{client ? client.cod : 'Sin Cliente'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>NIT: </span>
                        <span>{client ? client.identification : 'Sin Cliente'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Orden de compra: </span>
                        <span>{order ? order.purchase_order : 'Sin orden de compra'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Dirección de envío: </span>
                        <span>{order?.address_delivery}</span>
                    </div>
                    <Divider />
                    {
                    order.ordersDetail.length === 0 ? (
                        <>No hay detalle</>
                    ) : (
                        <div style={{width: '100%', marginTop: '10px'}}>
                            <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Producto</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>Color</div>
                                <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Cantidad</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>Medida</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>Precio</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>Pendiente</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>Reservado</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>Despachado</div>
                                <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Acciones</div> 
                            </div>
                            <div style={{width: '100%', overflowY: 'auto', height: '300px'}}>
                            {
                                
                                order.ordersDetail.map((d,key) => {
                                    return(
                                        <div key={key} style={{width: '100%'}}>
                                            <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                            <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>{d.productPrice.product ? d.productPrice.product.ref : ""}</div>
                                            <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>{d.color.cod }</div>
                                            <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>{d.quantity}</div>
                                            <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>{d.type_quantity}</div>
                                            <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>{d.price}</div>
                                            <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>{d.quantity-d.total_remi-d.total_desp-d.total_fact}</div>
                                            <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>{d.total_desp}</div>
                                            <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>{d.total_remi}</div>
                                            <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>
                                            <IconButton size='small' color="primary"  onClick={() => { 
                                                    props.searchSpecificInfo(d.uuid_details); 
                                                    }}>
                                                <SearchIcon /> 
                                            </IconButton>  
                                            </div>
                                            
                                            </div>
                                            <Divider />
                                        </div>
                                    )
                                })
                                  
                            }
                            </div>
                        </div>
                    )
                    }
                    <Divider />
                    <Divider />
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Nota: </span>
                        <span>{order?.notes}</span>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}

export default InfoOrderModal;
